import { ORDER_STATUS, type OrderTableSettingsData } from '@frontend/api';

import type { OrderListTabId } from 'modules/orders/listPage/types';

import {
  ORDER_LIST_TABS_STATIC_DATA,
  ORDER_TABLE_COLUMN_IDS,
  ORDER_TABLE_COLUMN_ID_TO_CONFIG_MAP,
} from '../const';
import type { OrderListTabConstraint } from '../types';

export type UseOrderListTabsParams = {
  orderTableSettings: OrderTableSettingsData;
};

/**
 * Util to get the tabs for the order list page table with their column configs.
 */
export const getOrderListTabs = ({
  orderTableSettings,
}: UseOrderListTabsParams) => {
  const allVisibleColumns = ORDER_TABLE_COLUMN_IDS.filter(
    (columnId) => orderTableSettings[columnId],
  ).map((columnId) => ORDER_TABLE_COLUMN_ID_TO_CONFIG_MAP[columnId]);

  const baseTabs = ORDER_LIST_TABS_STATIC_DATA;

  const orderListTabs = {
    [ORDER_STATUS.ALL]: {
      ...baseTabs[ORDER_STATUS.ALL],
      columns: allVisibleColumns,
    },
    [ORDER_STATUS.PENDING]: {
      ...baseTabs[ORDER_STATUS.PENDING],
      columns: allVisibleColumns,
    },
    [ORDER_STATUS.CONFIRMED]: {
      ...baseTabs[ORDER_STATUS.CONFIRMED],
      columns: allVisibleColumns,
    },
    [ORDER_STATUS.IN_PROCESS]: {
      ...baseTabs[ORDER_STATUS.IN_PROCESS],
      columns: allVisibleColumns,
    },
    [ORDER_STATUS.ON_HOLD]: {
      ...baseTabs[ORDER_STATUS.ON_HOLD],
      columns: allVisibleColumns,
    },
    [ORDER_STATUS.CANCELLED]: {
      ...baseTabs[ORDER_STATUS.CANCELLED],
      columns: allVisibleColumns,
    },
    [ORDER_STATUS.COMPLETED]: {
      ...baseTabs[ORDER_STATUS.COMPLETED],
      columns: allVisibleColumns,
    },
  } as const;

  // Using variable with type annotation as substitute for satisfies, which is
  // not yet available in the version of TypeScript we're using.
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const typeCheck: {
    [TabId in OrderListTabId]: OrderListTabConstraint;
  } = orderListTabs;
  /* eslint-enable @typescript-eslint/no-unused-vars */

  return orderListTabs;
};
